module.exports = "<mat-spinner class=\"spinner\"></mat-spinner>\n<div class=\"info\" *ngIf=\"message\">{{message}}</div>"